import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import { buscarImovel, obterUrlImagem } from '../../services/api';
import styles from './DetalheImovel.module.css';

function montarTituloPublico(imovel) {
  if (imovel.endereco) {
    return `${imovel.tipo_imovel || 'Imovel'} em ${imovel.endereco}`;
  }

  return `${imovel.tipo_imovel || 'Imovel'} para ${imovel.tipo_operacao || 'negocio'}`;
}

export default function DetalheImovel() {
  const { id } = useParams();
  const [imovel, setImovel] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState('');

  useEffect(() => {
    const carregar = async () => {
      setCarregando(true);
      setErro('');
      try {
        const dados = await buscarImovel(id);
        setImovel(dados.imovel || null);
      } catch (err) {
        setErro(err.message || 'Não foi possível carregar o imóvel.');
      } finally {
        setCarregando(false);
      }
    };

    if (id) {
      carregar();
    }
  }, [id]);

  const imagens = imovel?.imagensChave?.length
    ? imovel.imagensChave
    : imovel?.imagemChave
      ? [imovel.imagemChave]
      : [];

  return (
    <>
      <Header />
      <section className={styles.container}>
        {carregando && <p>Carregando imóvel...</p>}
        {erro && <p className={styles.erro}>{erro}</p>}

        {!carregando && !erro && imovel && (
          <>
            <Link to="/imoveis" className={styles.voltar}>Voltar para resultados</Link>

            <div className={styles.topo}>
              <h1>{montarTituloPublico(imovel)}</h1>
              {imovel.valor && (
                <p className={styles.preco}>
                  {Number(imovel.valor).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </p>
              )}
            </div>

            <p className={styles.meta}>
              {imovel.tipo_operacao} • {imovel.tipo_imovel}
            </p>
            <p className={styles.endereco}>{imovel.endereco || 'Endereço não informado'}</p>

            <div className={styles.galeria}>
              {imagens.length > 0 ? (
                imagens.map((chave) => (
                  <img key={chave} src={obterUrlImagem(chave)} alt={montarTituloPublico(imovel)} />
                ))
              ) : (
                <img src={`${process.env.PUBLIC_URL}/residencial.jpg`} alt={montarTituloPublico(imovel)} />
              )}
            </div>

            <article className={`${styles.descricao} ui-surface`}>
              <h2>Descrição</h2>
              <p>{imovel.descricao || 'Sem descrição cadastrada.'}</p>
            </article>

            {Array.isArray(imovel.tags) && imovel.tags.length > 0 && (
              <div className={styles.tags}>
                {imovel.tags.map((tag) => (
                  <span key={tag}>{tag}</span>
                ))}
              </div>
            )}
          </>
        )}
      </section>
      <Footer />
    </>
  );
}
